export interface ParticipantDraft {
  key: string;
  contactId?: string;
  email: string;
  name: string | null;
  isNewContact?: boolean;
}

export interface ScriptFormParticipantSummary {
  id: string;
  contact_id: string;
  script_form_id?: string;
  contacts: {
    id: string;
    name: string | null;
    email: string;
  } | null;
}

export const normaliseEmail = (email: string) => email.trim().toLowerCase();

export const buildParticipantKey = (email: string, suffix: string = "") => {
  const base = normaliseEmail(email);
  return suffix ? `${base}-${suffix}` : base;
};
